





































import { mapState, mapGetters, mapActions } from 'vuex'
import DefaultNavItemContent from '~/components/car/dealers/site/nav/NavItemContent/DefaultNavItemContent.vue'
import SearchPageNavItemContent from '~/components/car/dealers/site/nav/NavItemContent/SearchPageNavItemContent.vue'
import { mapDeps } from '~/plugins/dependency-container/utils'
import DealerSiteComponentService from '~/services/dealers/site/DealerSiteComponentService'
import DealerSiteService from '~/services/dealers/site/DealerSiteService'
import { DEALER_SITE_NS } from '~/store/modules/shared/dealers/site/state'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    DefaultNavItemContent,
    SearchPageNavItemContent
  },
  computed: {
    ...mapDeps({
      dealerSiteService: DealerSiteService,
      dealerSiteComponentService: DealerSiteComponentService
    }),
    ...mapState(DEALER_SITE_NS, ['pageSnippets', 'websiteId']),
    ...mapGetters(DEALER_SITE_NS, [
      'getTemplateOption',
      'activePageId',
      'navPages'
    ]),
    textColor(): string {
      return this.getTemplateOption('menu_link_color')
    },
    backgroundColor(): string {
      return this.getTemplateOption('menu_background_color')
    }
  },
  methods: {
    ...mapActions(DEALER_SITE_NS, {
      dispatchNavigationToPage: 'navigateToPage'
    }),
    navigateToPage(e: Event, id: string) {
      e.preventDefault()
      if (this.activePageId !== id) {
        this.dispatchNavigationToPage(id)
      }
    }
  }
})
